import { n, t } from '../l10n'

export default {
	methods: {
		n,
		t,
	},
}
